// extracted by mini-css-extract-plugin
export default {"logoWrapper":"pzoneLogo_logoWrapper__w9uOK","logoWidth":"pzoneLogo_logoWidth__KcK6e"};